export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="rounded-2xl bg-background-100 border border-background-200/70 p-8 md:p-12">
          <div className="text-center max-w-2xl mx-auto">
            <div className="w-14 h-14 rounded-xl bg-primary-100/70 flex items-center justify-center mx-auto mb-5">
              <i className="ri-mail-send-line text-2xl text-primary-600"></i>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">联系我们</h2>
            <p className="text-foreground-500 text-sm md:text-base mb-8">
              有漫画推荐、投稿合作或任何想法？欢迎随时联系我们。
              商务合作、版权咨询、内容建议，番茄漫画团队期待你的声音。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="mailto:contact@fanqiecomic.com"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line"></i>
                发送邮件
              </a>
              <a
                href="#faq"
                className="inline-flex items-center gap-2 px-6 py-3 border-2 border-foreground-200 text-foreground-700 rounded-full text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-question-answer-line"></i>
                查看常见问题
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}